import React from 'react';

import {
    ReviewRequestConfig,
    useReviews,
    ReviewFieldSelection,
    UserFieldSelection,
    ReviewResponseFieldSelection,
    ReviewOrdering,
} from '@/lib/hooks/use-reviews';

import {Reviews} from './reviews.react-component';
import type {ReviewsContext} from './types';
import styles from './reviews-container.module.scss';
import {useClpCourse} from '@/features/course-landing-page/context/clp-course-provider.react-component';

export interface ReviewsContainerProps {
    courseId: number;
    className?: string;
}

export const ReviewsContainer = ({courseId, className}: ReviewsContainerProps) => {
    const {rating} = useClpCourse();
    const reviewsConfig: ReviewRequestConfig = {
        courseId: courseId.toString(),
        pageSize: 12,
        isTextReview: true,
        fields: [ReviewFieldSelection.RATING],
        userFields: [UserFieldSelection.IMAGE, UserFieldSelection.DISPLAY_NAME],
        responseFields: [
            ReviewResponseFieldSelection.CONTENT,
            ReviewResponseFieldSelection.USER,
            ReviewResponseFieldSelection.CREATED,
            ReviewResponseFieldSelection.ID,
        ],
        ordering: [ReviewOrdering.REVIEW_SCORE_RANK, ReviewOrdering.CREATED_DESC],
    };

    const {data: reviews, isLoading, ratingDistribution, averageRating} = useReviews(reviewsConfig);

    // By default, use the GraphQL course avg rating, but use the reviews API average rating as a fallback
    const courseAverageRating = rating?.average ?? averageRating;
    const reviewsRatings: ReviewsContext = {
        averageRating: courseAverageRating,
        ratingDistribution,
        courseId,
        page: (reviewsConfig.page ?? 1).toString(),
    };

    return (
        <Reviews
            reviews={reviews}
            isLoading={isLoading}
            reviewsRatings={reviewsRatings}
            reviewableObjectType="course"
            reviewableObjectId={courseId}
            className={className}
            courseId={courseId}
            mobileCarouselClassName={styles['carousel-mobile-full-bleed-grid']}
            tabletCarouselClassName={styles['carousel-tablet-full-bleed-single-item-grid']}
        />
    );
};
